import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { API, setError } from '.'


export const fetchSimilar = createAsyncThunk('similar/fetchSimilar', async (_, thunkAPI) => {
   try {
      const response = await API.get(`/cardsSlice`, { params: { type: 'similar' } })
      return response.data
   } catch (err) {
      thunkAPI.dispatch(setError({ action: 'fetchSimilar', code: err.response.status, message: err.message }))
      return thunkAPI.rejectWithValue()
   }
})

const initialState = {
   entities: [],
   status: 'init'
}

const similarSlice = createSlice({
   name: 'similar',
   initialState,
   extraReducers: builder => {
      builder.addCase(fetchSimilar.pending, state => {
         state.status = 'loading'
      })
      builder.addCase(fetchSimilar.fulfilled, (state, action) => {
         state.status = 'success'
         state.entities = action.payload
      })
      builder.addCase(fetchSimilar.rejected, state => {
         state.status = 'error'
      })
   }
})

export const similar = similarSlice.reducer
